import Campaign from '@/models/campaign'

export default {
  campaigns: [],
  campaign: new Campaign().getObject(),
  isNew: false,
  isTemplate: false,
  currentCampaignId: null,
  registrants: [],
  translations: {},
  selectedLanguage: 'ENG',
  inviting: false
}
